import * as React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import ImageGallery from '../ImageGallery';
import { BestSellersGalleryQuery } from './__generated__/BestSellersGalleryQuery.graphql';

const BestSellersRenderer = ({ environment, accountId, ...props }) => {
  return (
    <QueryRenderer<BestSellersGalleryQuery>
      variables={{ accountId }}
      dataFrom="STORE_THEN_NETWORK"
      environment={environment}
      query={graphql`
        query BestSellersGalleryQuery($accountId: String) {
          viewer {
            id
            userInfo(accountId: $accountId) {
              id
              ...ImageGallery_user
              bestSellers(first: 4, sortBy: "bestSellers", category: "wine") {
                edges {
                  node {
                    id
                    productId
                    name
                    price
                    priceSale
                    inStockOn
                    inventoryClass
                    inventoryQuantity
                    inventorySKU
                    reviewAverage
                    productURLslug
                    optionsId
                    options {
                      id
                      optionId
                      optionName
                      choiceStyle
                      options {
                        optionName
                      }
                    }
                    promoCodeDiscount {
                      case4Cause {
                        case12PriceUSD
                        case6PriceUSD
                      }
                    }
                    images {
                      productCatalog
                    }
                    content {
                      impactSmall
                    }
                    ...ProductListItem_product
                  }
                }
              }
            }
          }
        }
      `}
      render={({ error, props: propsFromRender }) => {
        if (error) {
          return <div />;
        }
        if (
          propsFromRender &&
          propsFromRender.viewer &&
          propsFromRender.viewer.userInfo
        ) {
          return (
            <ImageGallery
              {...props}
              accountId={accountId}
              user={propsFromRender.viewer.userInfo}
              galleryImages={propsFromRender.viewer.userInfo.bestSellers}
            />
          );
        }
        return <div />;
      }}
    />
  );
};

export default BestSellersRenderer;
